export const contractState: { [key: string]: any } = {
    publicationId: '',
    mileage: 10000,
    duration: 12,
    rateNet: 0,
    rateGross: 0,
    totalPriceNet: 0,
    totalPriceGross: 0,
    leasmanMasterId: '',
    leasmanContractId: '',
};
